import React, { useMemo, useState } from 'react';
import {
  Box,
  Typography,
  Card,
  CardContent,
  Grid,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  Autocomplete,
} from '@mui/material';
import { Save, ArrowBack } from '@mui/icons-material';
import { useHistory } from 'react-router-dom';

const AMCScheduleCreate = () => {
  const history = useHistory();

  const technicians = useMemo(() => ([
    { id: 'T-001', name: 'Amit Kumar', phone: '+91 90000 00001' },
    { id: 'T-002', name: 'Riya Sharma', phone: '+91 90000 00002' },
    { id: 'T-004', name: 'Suresh Yadav', phone: '+91 98765 00004' },
  ]), []);
  const frequencies = ['Monthly', 'Quarterly', 'Half-Yearly', 'Yearly'];

  const [form, setForm] = useState({
    amcId: '',
    customerId: '',
    customerName: '',
    product: '',
    installationDate: '',
    amcStart: '',
    amcEnd: '',
    frequency: '',
    nextServiceDate: '',
    technicianId: '',
    technicianName: '',
    technicianPhone: '',
    maintenanceType: 'Preventive',
    status: 'Scheduled',
    lastServiceDate: '',
    remarks: '',
  });

  const computeAmcEnd = (start, freq) => {
    if (!start) return '';
    const d = new Date(start);
    if (freq === 'Yearly') d.setFullYear(d.getFullYear() + 1);
    if (freq === 'Half-Yearly') d.setMonth(d.getMonth() + 6);
    if (freq === 'Quarterly') d.setMonth(d.getMonth() + 3);
    if (freq === 'Monthly') d.setMonth(d.getMonth() + 1);
    return d.toISOString().slice(0, 10);
  };

  const handleSave = () => {
    if (!form.customerName || !form.product || !form.amcStart || !form.frequency || !form.technicianId) {
      alert('Please fill required fields: Customer, Product, AMC Start, Frequency, Technician');
      return;
    }
    console.log('AMC Create payload:', form);
    alert('AMC schedule created (demo)');
    history.push('/app/green-energy/service/amc-schedule');
  };

  return (
    <Box sx={{ p: 3, backgroundColor: '#f5f5f5', minHeight: '100vh' }}>
      <Box sx={{ mb: 3 }}>
        <Box display="flex" justifyContent="space-between" alignItems="center" flexWrap="wrap" gap={2}>
          <Box>
            <Typography variant="h4" sx={{ fontWeight: 700, color: '#000', mb: 0.5 }}>
              AMC / Maintenance - Add Schedule
            </Typography>
            <Typography variant="body2" color="text.secondary">Create a new AMC schedule</Typography>
          </Box>
          <Button variant="outlined" startIcon={<ArrowBack />} onClick={() => history.push('/app/green-energy/service/amc-schedule')}>Back</Button>
        </Box>
      </Box>

      <Card>
        <CardContent>
          <Grid container spacing={2}>
            <Grid item xs={12} md={3}>
              <TextField fullWidth size="small" label="AMC ID" value={form.amcId} onChange={(e) => setForm(prev => ({ ...prev, amcId: e.target.value }))} />
            </Grid>
            <Grid item xs={12} md={3}>
              <TextField fullWidth size="small" label="Customer ID" value={form.customerId} onChange={(e) => setForm(prev => ({ ...prev, customerId: e.target.value }))} />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField fullWidth size="small" label="Customer Name" value={form.customerName} onChange={(e) => setForm(prev => ({ ...prev, customerName: e.target.value }))} />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField fullWidth size="small" label="Product / System" value={form.product} onChange={(e) => setForm(prev => ({ ...prev, product: e.target.value }))} />
            </Grid>
            <Grid item xs={12} md={3}>
              <TextField fullWidth size="small" type="date" label="Installation Date" InputLabelProps={{ shrink: true }} value={form.installationDate} onChange={(e) => setForm(prev => ({ ...prev, installationDate: e.target.value }))} />
            </Grid>
            <Grid item xs={12} md={3}>
              <TextField fullWidth size="small" type="date" label="AMC Start Date" InputLabelProps={{ shrink: true }} value={form.amcStart} onChange={(e) => {
                const amcStart = e.target.value;
                const amcEnd = computeAmcEnd(amcStart, form.frequency);
                setForm(prev => ({ ...prev, amcStart, amcEnd }));
              }} />
            </Grid>
            <Grid item xs={12} md={3}>
              <TextField fullWidth size="small" type="date" label="AMC End Date" InputLabelProps={{ shrink: true }} value={form.amcEnd} onChange={(e) => setForm(prev => ({ ...prev, amcEnd: e.target.value }))} />
            </Grid>
            <Grid item xs={12} md={3}>
              <FormControl fullWidth size="small">
                <InputLabel>Service Frequency</InputLabel>
                <Select value={form.frequency} label="Service Frequency" onChange={(e) => {
                  const frequency = e.target.value;
                  const amcEnd = computeAmcEnd(form.amcStart, frequency);
                  setForm(prev => ({ ...prev, frequency, amcEnd }));
                }}>
                  {frequencies.map(f => <MenuItem key={f} value={f}>{f}</MenuItem>)}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={3}>
              <TextField fullWidth size="small" type="date" label="Next Service Date" InputLabelProps={{ shrink: true }} value={form.nextServiceDate} onChange={(e) => setForm(prev => ({ ...prev, nextServiceDate: e.target.value }))} />
            </Grid>
            <Grid item xs={12} md={4}>
              <Autocomplete
                size="small"
                options={technicians}
                getOptionLabel={(o) => o ? `${o.name} • ${o.phone}` : ''}
                value={technicians.find(t => t.id === form.technicianId) || null}
                onChange={(_, value) => setForm(prev => ({ ...prev, technicianId: value?.id || '', technicianName: value?.name || '', technicianPhone: value?.phone || '' }))}
                renderInput={(params) => <TextField {...params} label="Technician Assigned" />}
                clearOnEscape
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <TextField fullWidth size="small" label="Technician Contact" value={form.technicianPhone} InputProps={{ readOnly: true }} />
            </Grid>
            <Grid item xs={12} md={3}>
              <FormControl fullWidth size="small">
                <InputLabel>Status</InputLabel>
                <Select value={form.status} label="Status" onChange={(e) => setForm(prev => ({ ...prev, status: e.target.value }))}>
                  <MenuItem value="Upcoming">Upcoming</MenuItem>
                  <MenuItem value="Scheduled">Scheduled</MenuItem>
                  <MenuItem value="In Progress">In Progress</MenuItem>
                  <MenuItem value="Completed">Completed</MenuItem>
                  <MenuItem value="Overdue">Overdue</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={3}>
              <FormControl fullWidth size="small">
                <InputLabel>Maintenance Type</InputLabel>
                <Select value={form.maintenanceType} label="Maintenance Type" onChange={(e) => setForm(prev => ({ ...prev, maintenanceType: e.target.value }))}>
                  <MenuItem value="Preventive">Preventive</MenuItem>
                  <MenuItem value="Corrective">Corrective</MenuItem>
                  <MenuItem value="Emergency">Emergency</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <TextField fullWidth size="small" type="date" label="Last Service Date" InputLabelProps={{ shrink: true }} value={form.lastServiceDate} onChange={(e) => setForm(prev => ({ ...prev, lastServiceDate: e.target.value }))} />
            </Grid>
            <Grid item xs={12}>
              <TextField fullWidth size="small" multiline rows={2} label="Remarks / Notes" value={form.remarks} onChange={(e) => setForm(prev => ({ ...prev, remarks: e.target.value }))} />
            </Grid>
          </Grid>
        </CardContent>
      </Card>

      <Box mt={2} display="flex" gap={1} justifyContent="flex-end">
        <Button variant="outlined" startIcon={<ArrowBack />} onClick={() => history.push('/app/green-energy/service/amc-schedule')}>Cancel</Button>
        <Button variant="contained" startIcon={<Save />} onClick={handleSave} sx={{ backgroundColor: '#536DFE', '&:hover': { backgroundColor: '#3F51B5' } }}>Save Schedule</Button>
      </Box>
    </Box>
  );
};

export default AMCScheduleCreate;


